import React, { Fragment, useEffect, useState } from "react";
import { gAPI_PROPERTIES } from "../../constants/api";
import moment from "moment";
import axios from "axios";
import IntlMessage from "../helpers/IntlMessages";
const styles = ` <style>
        table {
            width: 100%;
            border-collapse: collapse;
        }
      
        img {
            width: 150px;
            height: 100px;
        }

        .fui-FluentProviderr0 {
  --fontSizeBase300: 10px!mportant;
  --lineHeightBase300: 5px!mportant;
}


    </style>`;

const Rates = ({ pid, handleReply, handleAppendContent, gid, functionArguments, propertyIntegration }) => {
  const [startDate, setStartDate] = useState(
    functionArguments?.checkInDate || moment().add("days", 1).format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    functionArguments?.checkOutDate || moment().add("days", 2).format("YYYY-MM-DD")
  );
  const [bookingEngineUrl, setBookingEngineUrl] = useState("");
  const [adults, setAdults] = useState(functionArguments?.numberOfAdults || 2);
  const [childrens, setChildrens] = useState(functionArguments?.numberOfChildren || 0);
  const [specialCodes, setSpecialCodes] = useState(functionArguments?.promoCode || "");
  const [roomsList, setRoomsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRatesData, setSelectedRatesData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showRateModal, setShowRateModal] = useState(false);
  const [exactMatchCode, setExactMatchCode] = useState(false);
  const [selectedRoomData, setSelectedRoomData] = useState([]);
  const [bookingEngineData, setBookingEngineData] = useState({ dateFormat: "", bookingUrl: "" });
  const [expandedRates, setExpandedRates] = useState([]);
  const [showPriceWithTax, setShowPriceWithTax] = useState(false);
  const [ratesSearched, setRatesSearched] = useState(false);
  useEffect(() => {
    setSelectedRoomData([]);
    axios(`${process.env.REACT_APP_API_URL}/searchbookingengineurl?propertyId=${pid}&groupId=${gid}`, {
      method: "get",
    }).then(async (engineRes) => {
      const dateFormat = engineRes.data.result.dateFormat;
      let bookingUrl = engineRes.data.result.bookingUrl;
      setBookingEngineData({ dateFormat: dateFormat, bookingUrl: bookingUrl });
    });
  }, [pid]);

  const calculatePrice = (price) => {
    let diff = moment(endDate).diff(moment(startDate), "days");
    console.log('price', diff, price)
    return Math.round((price / diff) * 100) / 100;
  };

  const formatPrice = (price, currency) => {
    if (price === undefined || price === null || price === "") return "";
    const num = Number(price);
    if (isNaN(num)) return price;
    return currency ? `${currency} ${num.toFixed(2)}` : num.toFixed(2);
  };

  const handleExactMatchCode = (e) => setExactMatchCode(e.target.checked);

  const handleAvailability = () => {
    fetch(gAPI_PROPERTIES + `/${pid}/rooms`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((res) => {
        let lstrooms = res?.rooms || [];
        let checkInDate = startDate;
        let checkOutDate = endDate;
        let group = functionArguments?.group;
        let location = functionArguments?.location;
        let responseFormat = functionArguments?.responseFormat;
        let promoCode = specialCodes;
        let bestRate = false;
        let availableAreas = functionArguments?.availableAreas || false;
        formatUrl({ group, location, promoCode });
        let rmsPropertyId = '';
        if (propertyIntegration?.Channel === 'Sabre') rmsPropertyId = pid;
        let availabilityurl = `${process.env.REACT_APP_PARTNER_URL}/public/availability/${propertyIntegration?.Id}?propertyId=${rmsPropertyId}&children=${childrens}&promoCode=${promoCode}&availableAreas=${availableAreas}&bestRate=false&exactMatch=${exactMatchCode}&ratePlanCode=&channel=${propertyIntegration?.Channel}&rooms=1&group_id=${gid}&adults=${adults}&dateIn=${checkInDate}&dateOut=${checkOutDate}&discount=${0}`;
        fetch(availabilityurl, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((json) => {
            if (json.roomTypes !== undefined && json.roomTypes?.length > 0) {
              json.roomTypes.map((m) => {
                let image = "";
                if (lstrooms !== undefined && lstrooms?.length > 0) {
                  image =
                    lstrooms.filter(
                      (f) =>
                        (f?.provider === propertyIntegration?.Channel || f?.provider === "RMS") &&
                        f?.providerRoomCode == m?.roomTypeCode
                    )[0]?.images[0]?.url ?? "";
                }
                m.roomImage = image === "" ? m.roomImage : image;
              });
              setRoomsList(json.roomTypes);
              // setShowModal(true);
            }
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      });
  };

  const formatUrl = ({ group, location, promoCode }) => {
    let bookingUrl = bookingEngineData?.bookingUrl;
    let dateFormat = bookingEngineData?.dateFormat;
    bookingUrl = bookingUrl.replace("{CHECK_IN}", moment(startDate).format(dateFormat));
    bookingUrl = bookingUrl.replace("{CHECK_OUT}", moment(endDate).format(dateFormat));
    bookingUrl = bookingUrl.replace("{ADULTS}", adults);
    bookingUrl = bookingUrl.replace("{CHILDREN}", childrens);
    bookingUrl = bookingUrl.replace("{categoryGroup}", group);
    bookingUrl = bookingUrl.replace("{location}", location);
    bookingUrl = bookingUrl.replace("{LANGUAGE}", "en");
    bookingUrl = bookingUrl.replace("{PromoCode}", promoCode);
    bookingUrl = bookingUrl.replace("{ROOM_TYPE}", "");
    setBookingEngineUrl(bookingUrl);
  };

  const handleSelect = (id) => {
    let lst = [...selectedRoomData];
    if (lst.includes(id) === true) setSelectedRoomData(lst.filter((f) => f !== id));
    else {
      lst.push(id);
      setSelectedRoomData(lst);
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setShowRateModal(true);
  }

  const closeRateModal = () => setShowRateModal(false);

  const openRateModal = () => setShowRateModal(true);

  const handleSelectedRatesData = (roomTypeCode, ratePlanCode) => {
    let lst = [...selectedRatesData];
    if (lst?.some((item) => item.roomTypeCode === roomTypeCode && item.ratePlanCode === ratePlanCode) === true) setSelectedRatesData(lst?.filter((f) => !(f.roomTypeCode === roomTypeCode && f.ratePlanCode === ratePlanCode)));
    else {
      lst.push({ roomTypeCode, ratePlanCode });
      setSelectedRatesData(lst);
    }

  }

  const toggleRates = (roomTypeCode) => {
    let lst = [...expandedRates];
    if (lst?.includes(roomTypeCode) === true) setExpandedRates(lst?.filter((f) => f !== roomTypeCode));
    else {
      lst.push(roomTypeCode);
      setExpandedRates(lst);
    }
  };

  const handleAddRates = () => {
    setLoading(true);
    console.log(bookingEngineUrl, 'bookingEngineUrl', roomsList, selectedRoomData);
    let text = `<p>Here are the available rates for ${adults} adults and ${childrens} children from ${startDate} to ${endDate}. <a style='fontSize: 14px;'  href='${bookingEngineUrl}'>Book Here</a> </p><hr/><table>`;
    let diff = moment(endDate).diff(moment(startDate), "days");
    selectedRatesData
      .map((d, index) => {
        let roomType = roomsList.filter((f) => f?.roomTypeCode === d?.roomTypeCode)[0];
        let r = roomType?.rates?.filter((f) => d.ratePlanCode === f?.ratePlanCode)[0];
        const imageContent = roomType?.roomImage
          ? `<img src="${roomType?.roomImage}" alt="Room Image"
              style="width:150px;height:auto;" />`
          : ``;
        text += `<tr><td style='border: 1px solid black;verticalAlign: top'><table><tr><td>
              ${imageContent}
              </td><td style='padding:5px 10px'>                            
              <h5 style='margin: 0'}}><b>${roomType?.roomTypeName || ""}</b></h5>
              <p style='margin: 5px 0; font-size: 14px; '>${r?.ratePlanName}</p>
              <p style='margin: 5px 0; font-size: 14px; '>${roomType?.currencyCode} ${formatPrice(calculatePrice(showPriceWithTax ? (r?.amountAfterTaxAndFees ?? r?.price) : (r?.amountBeforeTaxAndFees ?? r?.price)))} per night | ${diff} nights: ${formatPrice(showPriceWithTax ? (r?.amountAfterTaxAndFees ?? r?.price) : (r?.amountBeforeTaxAndFees ?? r?.price))} (${showPriceWithTax ? "incl. taxes & fees" : "excl. taxes & fees"})</p>              
              </td></tr></table></td></tr>`;
        setShowModal(false);
      });
    text += "</table>";
    console.log(text, 'text');
    handleAppendContent(text);
    setLoading(false);
  };

  const showTemplatePreview = (index, roomName, roomDescription, roomTypeCode, roomImage, price, ratePlanCode, rates, currency) => {
    let text = ``;
    let description = roomDescription.length > 100 ? roomDescription.substring(0, 100) + "...." : roomDescription;
    const otherRates = (rates || []).filter((rt) => rt?.ratePlanCode !== ratePlanCode);
    const count = otherRates.length;
    const nights = moment(endDate).diff(moment(startDate), "days");
    // text = text.replace("{roomImage}", roomImage);
    // text = text.replace("{ratePlan}", ratePlanCode);
    // text = text.replace("{roomDescription}", description);
    // text = text.replace("{roomName}", roomName);
    return (
      <Fragment>
        <div
          className="row mx-0"
          style={{
            border: "1px solid grey",
            // borderColor: `${selectedRoomData.includes(roomTypeCode) ? "green" : "black"}`,
            // borderWidth: `${selectedRoomData.includes(roomTypeCode) ? "2px" : "1px"}`,
            verticalAlign: "top",
            marginTop: "0.25rem",
            position: "relative",
          }}
        // onClick={() => handleSelect(roomTypeCode)}
        >
          {roomImage && roomImage !== "" ? (
            <div className="col-5" style={{ padding: "5px" }}>
              <img
                src={roomImage}
                alt="Room 1"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            </div>
          ) : null}
          <div className={roomImage && roomImage !== "" ? "col-7" : "col-12 ml-2"} style={{ padding: "0px 0px 10px" }}>
            <h5 style={{ margin: 0, fontSize: "13px", color: "#333", marginTop: "0.5rem" }}><b>{roomName}</b></h5>
            <div className="row" style={{ position: "absolute", right: "10px", marginTop: "0px", cursor: "pointer" }}>
              <svg
                onClick={() => handleSelectedRatesData(roomTypeCode, ratePlanCode)}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                width={25}
                height={25}
                style={{ fill: `${selectedRatesData.some(data => data.roomTypeCode === roomTypeCode && data.ratePlanCode === ratePlanCode) ? "lightgreen" : "white"}` }}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
                />
              </svg>
            </div>
            <h6 style={{ margin: "0", fontSize: "11px", color: "#555", lineHeight: "12px" }} className="mt-1">{description}</h6>
            <div style={{ margin: "5px 0", fontSize: "14px", color: "#555" }}>
              {/* <IntlMessage id="main.total" />:{" "} */}
            <p style={{marginBottom:"0px", fontSize: "11px",}}> {currency}{" "} 
              <b>
                {`${formatPrice(calculatePrice(price))}/night`}
              </b></p>
             <p style={{marginBottom:"0px", fontSize: "11px",}}> {` ${nights} ${nights === 1 ? "night" : "nights"}: `}
              <b>{formatPrice(price)}</b></p>
            </div>
            {count > 0 && (
              <p style={{ margin: "5px 0", fontSize: "12px", color: "#007bff", cursor: "pointer", textDecoration: "underline" }}>
                <span onClick={() => toggleRates(roomTypeCode)}>
                  {expandedRates.includes(roomTypeCode) ? "Hide rates" : `${count} more rate${count > 1 ? "s" : ""}`}
                </span>
              </p>
            )}
          </div>
        </div>
        {expandedRates.includes(roomTypeCode) && (
          <div>
            {otherRates.map((rt, idx) => (
              <div
                className="row mx-0"
                style={{
                  border: "1px solid grey",
                  // borderColor: `${selectedRoomData.includes(roomTypeCode) ? "green" : "black"}`,
                  // borderWidth: `${selectedRoomData.includes(roomTypeCode) ? "2px" : "1px"}`,
                  verticalAlign: "top",
                   marginTop: 8,
                  position: "relative",
                }}
              // onClick={() => handleSelect(roomTypeCode)}
              >
                <div className="col-12" style={{ padding: "5px" }}>
                  <div className="row" style={{ position: "absolute", right: "10px", marginTop: "0px", cursor: "pointer" }}>
                    <svg
                      onClick={() => handleSelectedRatesData(roomTypeCode, rt?.ratePlanCode)}
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1.5"
                      stroke="currentColor"
                      width={25}
                      height={25}
                      style={{ fill: `${selectedRatesData.some(data => data.roomTypeCode === roomTypeCode && data.ratePlanCode === rt?.ratePlanCode) ? "lightgreen" : "white"}` }}
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M9 12.75 11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 0 1-1.043 3.296 3.745 3.745 0 0 1-3.296 1.043A3.745 3.745 0 0 1 12 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 0 1-3.296-1.043 3.745 3.745 0 0 1-1.043-3.296A3.745 3.745 0 0 1 3 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 0 1 1.043-3.296 3.746 3.746 0 0 1 3.296-1.043A3.746 3.746 0 0 1 12 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 0 1 3.296 1.043 3.746 3.746 0 0 1 1.043 3.296A3.745 3.745 0 0 1 21 12Z"
                      />
                    </svg>
                  </div>
                  <div style={{ fontSize: "11px", color: "#555" }}>{rt?.ratePlanName || rt?.ratePlanCode}</div>
                  <div style={{ fontSize: "14px", color: "#555" }}>
                    {(() => {
                      const totalPrice = showPriceWithTax
                        ? (rt?.amountAfterTaxAndFees ?? rt?.price)
                        : (rt?.amountBeforeTaxAndFees ?? rt?.price);

                      return (
                        <>
                   <p style={{marginBottom:"0px", fontSize: "11px",}}>{currency}{" "}
                          <b>{`${formatPrice(calculatePrice(totalPrice))}/night`}</b></p>
                         <p style={{marginBottom:"0px", fontSize: "11px",}}>   {` ${nights} ${nights === 1 ? "night" : "nights"}: `}
                          <b>{formatPrice(totalPrice)}</b></p>
                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Fragment>
    );

  };

  const handleStartDate = (e) => {
    const newCheckIn = e.target.value;
    setStartDate(newCheckIn);
    const newCheckOut = moment(newCheckIn)
      .add(2, "days")
      .format("YYYY-MM-DD");

    setEndDate(newCheckOut);
  };

  const handleEndDate = (e) => setEndDate(e.target.value);

  const handleAdults = (e) => setAdults(e.target.value);

  const handleChildrens = (e) => setChildrens(e.target.value);

  const handleSpecialCodes = (e) => setSpecialCodes(e.target.value);

  const handleShow = () => setShowModal(true);
  const handleSubmit = () => {
    setShowRateModal(false);
    setShowModal(true);
    setLoading(true);
    setRatesSearched(true);
    handleAvailability();
  };
  return (
    <Fragment>
      <div className="col-6 text-center">
        <button
          type="submit"
          onClick={openRateModal}
          className="btn-full btn border-green-dark reply-button"
          style={{ padding: "6px" }}
        >
          {/* <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            width={15}
            height={15}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15"
            />
          </svg> */}
          <span className="ml-1" style={{ textTransform: "none" }}>
            + Rates
          </span>
        </button>
      </div>
      {showRateModal && (
        <div
          className="row additional-modal"
          style={{
            height: "70%",
            position: "fixed",
            top: "40px",
            left: "0px",
            right: "0px",
          }}
        >
          <div className="modal-box">
            <div className="col-12">
              <div className="row mb-3" style={{ margin: "5px" }}>
                <div className="form-custom form-label mb-3">
                  <input
                    type="date"
                    onChange={handleStartDate}
                    value={startDate}
                    className="form-control rounded-xs  form-control"
                    id="startDate"
                    min={moment().format("YYYY-MM-DD")}
                  />
                  <label className="color-theme form-label-active"><IntlMessage id="main.check_in" /></label>
                </div>
                <div className="form-custom form-label mb-3">
                  <input
                    type="date"
                    onChange={handleEndDate}
                    value={endDate}
                    className="form-control rounded-xs  form-control"
                    id="endDate"
                    min={moment().format("YYYY-MM-DD")}
                  />
                  <label className="color-theme form-label-active"><IntlMessage id="main.check_out" /></label>
                </div>
                <div className="form-custom form-label mb-3">
                  <input
                    type="number"
                    onChange={handleAdults}
                    value={adults}
                    className="form-control rounded-xs  form-control"
                    id="adults"
                    min={1}
                  />
                  <label className="color-theme form-label-active"><IntlMessage id="main.adults" /></label>
                </div>
                <div className="form-custom form-label mb-3">
                  <input
                    type="number"
                    onChange={handleChildrens}
                    value={childrens}
                    className="form-control rounded-xs  form-control"
                    id="childrens"
                    min={0}
                  />
                  <label className="color-theme form-label-active"><IntlMessage id="main.children" /></label>
                </div>
                <div className="form-custom form-label mb-3">
                  <input
                    type="text"
                    onChange={handleSpecialCodes}
                    value={specialCodes}
                    className="form-control rounded-xs  form-control"
                    id="specialCodes"
                  />
                  <label className="color-theme form-label-active"><IntlMessage id="main.promocode" /></label>
                </div>
                {specialCodes && specialCodes !== "" && (
                  <div className="mb-3 exact-match">
                    <input
                      type="checkbox"
                      onChange={handleExactMatchCode}
                      checked={exactMatchCode}
                      className=""
                      id="exactMatchCode"
                    />
                    <label
                      htmlFor="exactMatchCode"
                      className="color-theme form-label-active"
                      style={{ fontWeight: 600 }}
                    >
                      <IntlMessage id="main.exact_match_only" />
                    </label>
                  </div>)}
              </div>
            </div>
            <div className="col-12">
              <button
                type="submit"
                onClick={handleSubmit}
                className="btn-full btn border-green-dark reply-button"
                style={{ padding: "6px" }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  width={15}
                  height={15}
                >
                  <path d="M6,14.1818182 L6,17.4545455 L18,17.4545455 L18,14.1818182 M12,6 L12,14 M8.18181818,9.81818182 L12,6 L15.8181818,9.81818182" />
                </svg>
                <span className="ml-1" style={{ textTransform: "none" }}>
                  <IntlMessage id="main.search" />
                </span>
              </button>
            </div>
          </div>
          <button className="close-btn" onClick={closeRateModal}>
            &times;
          </button>
        </div>
      )}
      {showModal && (
        <div
          className="row additional-modal"
          style={{
            height: "80%",
            position: "fixed",
            top: "10px",
            left: "0px",
            right: "0px",
            bottom: "20px",
          }}
        >
          <div className="modal-box">
            <style>{styles}</style>
            {loading ? (
              <div className="col-12">
                <div id="ari-rooms-loader" className="preloader-show col-12" style={{ top: "0px" }}>
                  <div
                    className="spinner-border color-highlight-myma"
                    role="status"
                    style={{ height: "1.5rem", width: "1.5rem" }}
                  ></div>
                </div>
              </div>
            ) : (
              <Fragment>
                <div className="col-12" style={{ padding: "0px 10px", maxHeight: "70vh", overflowY: "scroll", marginBottom: "2rem" }}>
                  {roomsList !== undefined && roomsList.length > 0 ? (
                    <Fragment>
                      <div style={{ display: "flex", marginBottom: 10 }}>
                        <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer", textDecoration: "underline" }} onClick={() => setShowPriceWithTax(!showPriceWithTax)}>
                          <span>{!showPriceWithTax ? "Show rates including taxes & fees" : "Show rates without taxes & fees"}</span>
                        </label>
                      </div>
                      <div className="mb-4">
                        {roomsList.map((d, index) => (
                          <Fragment key={index}>
                            {showTemplatePreview(
                              index,
                              d?.roomTypeName || "",
                              d?.minimumRate?.ratePlanName || "",
                              d?.roomTypeCode || "",
                              d?.roomImage || "",
                              showPriceWithTax ? (d?.minimumRate?.amountAfterTaxAndFees ?? d?.minimumRate?.price) : (d?.minimumRate?.amountBeforeTaxAndFees ?? d?.minimumRate?.price),
                              d?.minimumRate?.ratePlanCode || "",
                              d.rates,
                              d?.currencyCode
                            )}
                          </Fragment>
                        ))}
                      </div>
                      <div
                        className="item-center"
                        style={{
                          width: "90%",
                          position: "fixed",
                          bottom: "0px",
                          background: "white",
                          padding: "10px 0",
                          zIndex: 10,
                        }}
                      >
                        <button
                          type="button"
                          onClick={handleAddRates}
                          className="btn-full btn border-green-dark reply-button paste-button"
                          style={{ padding: "6px" }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1.5"
                            stroke="currentColor"
                            width={15}
                            height={15}
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M8.25 9V5.25A2.25 2.25 0 0 1 10.5 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 16.5 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m-3 0-3-3m0 0 3-3m-3 3H15"
                            />
                          </svg>
                          <span className="ml-1" style={{ textTransform: "none" }}>
                            <IntlMessage id="main.pastetooutlook" />
                          </span>
                        </button>
                      </div>
                    </Fragment>
                  ) : (
                    <Fragment>
                      {ratesSearched && !loading && (
                        <div style={{ padding: "20px", textAlign: "center", color: "#777" }}>
                          <IntlMessage id="main.no_rate_match" />
                        </div>
                      )}
                    </Fragment>
                  )}
                </div>
              </Fragment>
            )}
          </div>
          <button className="close-btn" onClick={closeModal}>
            &times;
          </button>
        </div>
      )}
    </Fragment>
  );
};

export default Rates;
